import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Alert } from '../../../../../Alert';
import { CheckboxGroup, TextInput } from '../../../../../Inputs';
import { useL10n } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { useMemo } from 'react';

export enum VerifiableInfoEnum {
  accountEmail = 'Account Email',
  dateOfBirth = 'Date of Birth',
  fullName = 'Full Name (legal or preferred)',
  homeAddress = 'Home Address',
  phoneNumber = 'Phone Number'
}
const verifiableInfo: string[] = Object.values(VerifiableInfoEnum);

export type EmailFormProps = {
  role: UserRole;
};

export const EmailForm: React.VFC<EmailFormProps> = ({ role }) => {
  const l10n = useL10n();
  const { classes } = useEmailStyles();

  const userRole = useMemo(() => {
    if (role === UserRole.patient) {
      return 'client';
    }
    return 'provider';
  },[ role ]);

  return (
    <Box className={classes.root}>
      <Alert severity="info" icon={false} className={classes.alert}>
        {l10n.accountSettings.emailSettings.toUpdateEmail(userRole)}
      </Alert>
      <div>
        <CheckboxGroup
          label={l10n.accountSettings.emailSettings.selectVerified}
          name="verifiableInfo"
          options={verifiableInfo}
          helperText={l10n.accountSettings.emailSettings.selectThree}
        />
      </div>

      <TextInput
        name="email"
        label="Account Email"
        color="secondary"
        helperText={l10n.accountSettings.emailSettings.changingEmail(userRole)}
        className={classes.input}
      />
    </Box>
  );
};

const useEmailStyles = makeStyles({ name: 'Email' })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(3)
  },
  alert: {
    display: 'inline-flex',
    width: 'auto',
    maxWidth: 'fit-content'
  },
  input: {
    maxWidth: '420px'
  }
}));
